// src/components/BrandMedicineSupply.js

import React from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Card,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import LocalPharmacyIcon from "@mui/icons-material/LocalPharmacy";
import VerifiedIcon from "@mui/icons-material/Verified";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import "./BrandMedicineSupply.css";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
const BrandMedicineSupply = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 600px)" });
  const navigate = useNavigate();
  return (
    <Container maxWidth="lg" className="brand-medicine-supply">
      <Box
        textAlign="center"
        sx={{
          position: "relative",
        }}
        // my={4}
      >
        <Typography
          variant="overline"
          display="block"
          gutterBottom
          onClick={() => navigate("/our-services")}
          sx={{
            position: "absolute",
            top: isMobile ? "-25px" : "10px",
            left: 0,
            fontSize: "10px",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          Back to list
        </Typography>
        <Typography
          variant="overline"
          display="block"
          gutterBottom
          sx={{
            position: "absolute",
            top: isMobile ? "-25px" : "10px",
            right: 0,
            fontSize: "10px",
            textDecoration: "underline",
          }}
        >
          OUR SERVICES
        </Typography>
        <Typography variant="h4" gutterBottom>
          Brand Medicine Supply
        </Typography>
      </Box>
      <Grid container spacing={4} mb={4}>
        <Grid item xs={12}>
          <Paper
            elevation={2}
            sx={{
              p: { xs: 2, sm: 4 },
              background:
                "linear-gradient(135deg, #f8fafc 0%,rgb(248, 254, 255) 100%)",
              borderRadius: 3,
            }}
          >
            <Typography
              variant="h5"
              fontWeight="bold"
              gutterBottom
              color="primary.dark"
            >
              Why Choose SAR Pharma International?
            </Typography>
            <Typography variant="body1" paragraph>
              SAR Pharma International takes pride in being a leading provider
              of generic and internationally branded medicines for patients
              worldwide. We understand the critical importance of ensuring
              access to high-quality medications, and our extensive network
              allows us to source and supply a wide range of internationally
              recognized pharmaceutical products.
            </Typography>
            <Typography variant="body1" paragraph>
              Our commitment to quality drives us to collaborate with reputable
              manufacturers and suppliers from across the globe. Through these
              partnerships, we can offer a comprehensive selection of
              internationally branded medicines, meeting the diverse needs and
              preferences of our clients and patients.
            </Typography>
            <Typography variant="body1" paragraph>
              By offering internationally branded medicines, we provide our
              customers with peace of mind regarding the authenticity, safety,
              and efficacy of the products they receive. We adhere to strict
              quality control measures throughout the supply chain, ensuring
              that every medication we distribute meets stringent international
              standards and regulations.
            </Typography>
            <Typography variant="body1" paragraph>
              SAR Pharma International understands that each patient's journey
              is unique, and their specific medical requirements may necessitate
              specific brands or formulations of medicine. Our extensive catalog
              encompasses a wide range of therapeutic categories, including:
            </Typography>
            <Box component="ul" sx={{ pl: 3, mb: 2 }}>
              <li>
                <Typography variant="body1">
                  Oncology / Anti-cancer medicine
                </Typography>
              </li>
              <li>
                <Typography variant="body1">
                  Cardiovascular medications
                </Typography>
              </li>
              <li>
                <Typography variant="body1">Neurology treatments</Typography>
              </li>
              <li>
                <Typography variant="body1">Respiratory care</Typography>
              </li>
              <li>
                <Typography variant="body1">And much more...</Typography>
              </li>
            </Box>
            <Typography variant="body1" paragraph>
              Whether it's for chronic conditions or acute illnesses, we strive
              to fulfill the varied medication needs of our customers.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
      <Grid container spacing={1} my={2}>
        {[
          "/assets/images/bs2.png",
          "/assets/images/bs3.png",
          "/assets/images/bs1.png",
        ].map((src, index) => (
          <Grid
            item
            xs={12} // 1 image per row for small screens
            sm={6} // 2 images per row for small to medium screens
            md={4} // 3 images per row for medium and larger screens
            key={index}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={src}
              alt={`Brand Medicine Supply ${index + 1}`}
              style={{
                width: "100%",
                height: "400px",
                objectFit: "fiill",
              }}
            />
          </Grid>
        ))}
      </Grid>
      <div style={{ width: "100%" }}>
        <Grid container spacing={3} my={2} alignItems="stretch">
          {[
            {
              icon: <LocalPharmacyIcon color="primary" sx={{ fontSize: 40 }} />,
              title: "Extensive Product Range",
              desc: "Our catalog includes a diverse array of internationally recognized pharmaceutical products, ensuring that you have access to a wide selection of medicines.",
            },
            {
              icon: <VerifiedIcon color="primary" sx={{ fontSize: 40 }} />,
              title: "Authenticity and Quality",
              desc: "We prioritize the authenticity, safety, and efficacy of every medication we supply. Through stringent quality control measures, we ensure that all our products meet the highest industry standards.",
            },
            {
              icon: <AllInclusiveIcon color="primary" sx={{ fontSize: 40 }} />,
              title: "Reliable Supply Chain",
              desc: "With a robust global network of trusted manufacturers and suppliers, we ensure a steady and reliable supply of internationally branded medicines.",
            },
            {
              icon: <SupportAgentIcon color="primary" sx={{ fontSize: 40 }} />,
              title: "Expert Guidance",
              desc: "Our knowledgeable and experienced team is available to provide guidance and assistance in selecting the most suitable internationally branded medicines for your specific needs.",
            },
            {
              icon: <AttachMoneyIcon color="primary" sx={{ fontSize: 40 }} />,
              title: "Competitive Pricing",
              desc: "We understand the financial burden that can come with accessing branded medications. Therefore, we strive to offer cost-effective pricing without compromising on quality, making internationally branded medicines more accessible to patients worldwide.",
            },
          ].map((item, idx) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={idx}
              sx={{ display: "flex", height: "100%" }}
            >
              <Card
                elevation={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  p: 3,
                  textAlign: "center",
                  height: {
                    xs: 220, // small screens
                    sm: 300, // medium screens
                    md: 400,
                    lg: 350, // large screens
                  },
                  width: "100%",
                }}
              >
                <Box mb={2}>{item.icon}</Box>
                <Typography variant="h6" gutterBottom>
                  {item.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {item.desc}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </div>
      <Box textAlign="center" my={4}>
        <Typography variant="body1" paragraph>
          Choose SAR Pharma International as your trusted partner for
          international branded and generic medicine supply, and let us help you
          on your journey towards optimal health and well-being.
        </Typography>
      </Box>
    </Container>
  );
};

export default BrandMedicineSupply;
